export default __webpack_public_path__ + "static/media/devguide06.478f2ebe.md";